<template>
  <div>
    <div class="flex-box flex-v-c content">
      <div class="title">可查看商务:</div>

      <div class="flex1 dirBtn" @click="sortSwitch">
        <select id="sel" class="selectDistrict" v-model="selectId">
          <option value v-if="subManagerList.length==0">无可查看商务</option>
          <option
            :value="item.id"
            v-for="(item,index) in subManagerList"
            :key="item.id"
          >{{item.realname}}</option>
        </select>
        <!-- <i class="iconfont" :class="{iconXiajiantou:!sortListShow,iconShangjiantou:sortListShow}"></i> -->
        <i class="iconfont iconXiajiantou"></i>
      </div>
    </div>
    <div class="flex-box flex-hv-c yes" @click="yes" v-if="subManagerList.length>0">查看</div>
    <div class="flex-box flex-hv-c yes" v-else>无可查看商务</div>
    <transition name="trans">
      <detail :managerId="selectId" class="detail" v-if="detailShow" @ctrDetails="ctrDetails"></detail>
    </transition>
  </div>
</template>
<!--javascript-->
<script>
import Cloadmore from '../loadmore/loadmore.vue'
import detail from './detail.vue'
export default {
  components: { Cloadmore, detail },
  data: function () {
    return {
      selectId: '',
      selectDistrictList: [],
      sortListShow: false,//控制显示隐藏
      detailShow: false,
      managerId: localStorage.getItem('managerId')
    }
  },
  methods: {
    sortSwitch() {
      this.sortListShow = !this.sortListShow
    },
    ctrDetails(params) {
      this.detailShow = params;
    },
    yes() {
      this.ctrDetails(true)
    }
  },
  computed: {
    subManagerList() {
      return this.$store.state.userMsg.userMsg.subManagerList

    }
  },
  mounted: function () {
    // this.init()
  },
  created: function () {
    if (this.subManagerList[0]) {
      this.selectId = this.subManagerList[0].id
    }
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.title {
  padding: 10px;
}

.dirBtn {
  margin: 4px;
  height: 0.6rem;
  line-height: 0.6rem;
  min-width: 1.46rem;
  padding: 0 4px 4px 0;
  color: #000;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.content {
  width: 90%;
  margin: 1rem auto;
}

.selectDistrict {
  border: none;
  width: 88%;
  padding: 0 0 0 15px;
  outline: none;
}

.iconXiajiantou,
.iconShangjiantou {
  font-size: 0.2rem;
}

.yes {
  width: 90%;
  margin: 0.3rem auto;
  height: 0.6rem;
  border-radius: 4px;
  text-align: center;
  background: #3d435f;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/managerFind/index.vue